import { ArticleType, SubmissionFileType } from '@/types'

export function bytesFormatter(value: number) {
  // Start with KB
  var num = value * 0.001
  var units = 'kb'

  if (num > 1000) {
    // Move up to MB if sufficiently large
    num = num * 0.001
    units = 'mb'
  }

  return num.toFixed(1) + units
};

export function articleTypeFormatter(value: ArticleType) {
  switch (value) {
    case 'EdgeArticle': {
      return 'Edge Article'
    }
    case 'ReviewArticle': {
      return 'Review Article'
    }
    case 'Perspective': {
      return 'Perspective'
    }
    case 'Comment': {
      return 'Comment'
    }
  }
  return ''
};

export function submissionFileTypeFormatter(value: SubmissionFileType): string {
  switch (value) {
    case 'MainArticle': {
      return 'Manuscript file'
    }
    case 'CoverLetter': {
      return 'Cover letter / justification'
    }
    case 'Esi': {
      return 'Supplementary information'
    }
    case 'Figure': {
      return 'Figures'
    }
    case 'CrystalData': {
      return 'Crystal data'
    }
    case 'DAS': {
      return 'Data availability statement'
    }
  }

  return ''
};
